module.exports = __webpack_public_path__ + "061e7771182df0c8fd9202e3ce990fe7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-shapes/images/asscher@2x.png
// module id = 306
// module chunks = 0